/* Shared predictive-search behavior. Loaded once from layout/theme.liquid. */
(function () {
  // Shared styles are served by bot-search-suggestions.css.

  // ── Init each search instance ─────────────────────────────────────────────
  function initSearchInstance(input, dropdown) {
    let debounceTimer;
    let requestSerial = 0;
    const zeroQueryGroups = [
      {
        title: 'Popular brands',
        key: 'brands',
        items: [
          { label: 'Medicube', url: '/collections/medicube' },
          { label: 'Pastry Skincare', url: '/collections/pastry-skincare' },
          { label: 'Anua', url: '/collections/anua' },
          { label: 'Skin Functional', url: '/collections/skin-functional' },
        ],
      },
      {
        title: 'Popular searches',
        key: 'searches',
        items: [
          { label: 'Sunscreen', url: '/collections/sunscreen' },
          { label: 'Centella', url: '/collections/centella' },
          { label: 'Azelaic Acid', url: '/collections/azelaic-acid' },
          { label: 'Retinol', url: '/collections/retinol' },
          { label: 'Vitamin C', url: '/collections/vitamin-c' },
        ],
      },
    ];

    function normalizeQuery(value) {
      return String(value)
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/&/g, ' and ')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .replace(/\s+/g, ' ');
    }

    function getIntentMatch(value) {
      const normalized = normalizeQuery(value);
      const padded = ` ${normalized} `;
      const has = word => padded.includes(` ${word} `);
      const hasAny = words => words.some(has);
      const canonicalSearchUrl = term => `/search?q=${encodeURIComponent(term)}&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide`;

      if (normalized.includes('skinfunctional') || (has('skin') && has('functional'))) {
        let primary = {
          label: 'Shop available Skin Functional',
          url: canonicalSearchUrl('vendor:"Skin Functional"'),
        };
        if (hasAny(['serum', 'serums'])) {
          primary = { label: 'Skin Functional face serums', url: '/collections/skin-functional-face-serums' };
        }

        return {
          key: 'skin-functional',
          title: 'Skin Functional',
          destination: primary.url,
          items: [
            primary,
            { label: 'All Skin Functional products', url: '/collections/skin-functional' },
          ],
        };
      }

      if (has('retinol') && hasAny(['serum', 'serums'])) {
        return {
          key: 'retinol-serum',
          title: 'Retinol serums',
          destination: canonicalSearchUrl('title:retinol AND title:serum'),
          items: [
            { label: 'Shop retinol serums', url: canonicalSearchUrl('title:retinol AND title:serum') },
            { label: 'All retinol products', url: '/collections/retinol' },
          ],
        };
      }

      if (has('dry') && has('skin') && hasAny(['combo', 'combos', 'kit', 'kits', 'set', 'sets', 'bundle', 'bundles'])) {
        return {
          key: 'dry-skin-combo',
          title: 'Dry-skin kits & combos',
          destination: canonicalSearchUrl('tag:"Dry Skin" AND (title:combo OR title:kit OR title:set OR title:bundle)'),
          items: [
            { label: 'Shop dry-skin kits & combos', url: canonicalSearchUrl('tag:"Dry Skin" AND (title:combo OR title:kit OR title:set OR title:bundle)') },
            { label: 'Browse skincare kits', url: '/collections/skincare-combos-kits' },
            { label: 'Shop dry-skin care', url: '/collections/dry-skin' },
          ],
        };
      }

      if ((has('salicylic') || has('bha')) && hasAny(['scrub', 'scrubs', 'polish', 'polishes', 'exfoliator', 'exfoliators', 'exfoliating', 'exfoliation'])) {
        return {
          key: 'salicylic-body-scrub',
          title: 'Salicylic exfoliation',
          destination: canonicalSearchUrl('title:"Salicylic Acid Exfoliating Polish"'),
          items: [
            { label: 'Salicylic Acid Exfoliating Polish', url: canonicalSearchUrl('title:"Salicylic Acid Exfoliating Polish"') },
            { label: 'Salicylic acid products', url: '/collections/salicylic-acid' },
            { label: 'Body scrubs', url: '/collections/scrubs' },
          ],
        };
      }

      return null;
    }

    async function fetchSuggestions(query) {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][prefix]=last`;
      const res = await fetch(url);
      if (!res.ok) throw new Error('Search failed');
      return res.json();
    }

    function formatMoney(amount) {
      const currency = window.Shopify?.currency?.active || 'ZAR';
      const numericAmount = Number(amount);
      if (!Number.isFinite(numericAmount)) return '';
      return numericAmount.toLocaleString(undefined, { style: 'currency', currency });
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
    }

    // Split on the raw text FIRST, then escape each piece — escaping before the
    // regex would let queries like "amp" match inside generated entities.
    function highlight(text, query) {
      const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return String(text)
        .split(new RegExp(`(${escaped})`, 'gi'))
        .map((part, i) => (i % 2 ? `<strong>${escapeHtml(part)}</strong>` : escapeHtml(part)))
        .join('');
    }

    function renderZeroQuery() {
      const html = zeroQueryGroups.map(group => {
        const headingId = `${dropdown.id}-${group.key}-heading`;
        const pills = group.items.map(item =>
          `<a data-ss-url="${item.url}" class="ss-pill" role="option" aria-selected="false" data-instant>${escapeHtml(item.label)}</a>`
        ).join('');

        return `<div class="ss-section" role="group" aria-labelledby="${headingId}">
          <div class="ss-section-header">
            <span class="ss-section-title" id="${headingId}">${escapeHtml(group.title)}</span>
          </div>
          <div class="ss-pills">${pills}</div>
        </div>`;
      }).join('');

      dropdown.innerHTML = `<div class="ss-zero-query">${html}</div>`;
      finalizeOptions('zero');
    }

    function renderIntentSuggestions(intent) {
      const headingId = `${dropdown.id}-${intent.key}-heading`;
      const items = intent.items.map((item, index) =>
        `<a data-ss-url="${item.url}" class="ss-pill" role="option" aria-selected="false"${index === 0 ? ' data-instant' : ''}>${escapeHtml(item.label)}</a>`
      ).join('');

      dropdown.innerHTML = `<div class="ss-section" role="group" aria-labelledby="${headingId}">
        <div class="ss-section-header">
          <span class="ss-section-title" id="${headingId}">${escapeHtml(intent.title)}</span>
        </div>
        <div class="ss-pills">${items}</div>
      </div>`;
      finalizeOptions('intent');
    }

    function renderSuggestions(data, query) {
      const { products = [], collections = [] } = data.resources.results;
      let html = '';

      if (products.length) {
        html += `<div class="ss-section">
          <div class="ss-section-header">
            <span class="ss-section-title">Products</span>
            <a data-ss-url="/search?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide" class="ss-view-all" role="option" aria-selected="false">
              VIEW ALL
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </a>
          </div>
          <div class="ss-product-grid">`;
        products.slice(0, 4).forEach(p => {
          const isOnSale = Number(p.compare_at_price_max) > Number(p.price);
          const imgSrc = p.featured_image?.url ? `${p.featured_image.url}&width=128` : null;
          html += `
            <a data-ss-url="${p.url}" class="ss-product-item" role="option" aria-selected="false">
              <div class="ss-product-img-wrap">
                ${imgSrc ? `<img src="${imgSrc}" alt="${escapeHtml(p.title)}" width="64" height="64" loading="lazy">` : '<div class="ss-product-img-placeholder"></div>'}
                ${isOnSale ? `<span class="ss-sale-badge">Sale</span>` : ''}
              </div>
              <div class="ss-product-info">
                <span class="ss-product-title">${highlight(p.title, query)}</span>
                <div class="ss-product-price">
                  ${isOnSale
                    ? `<span class="sale">${formatMoney(p.price)}</span><span class="compare">${formatMoney(p.compare_at_price_max)}</span>`
                    : `<span>${formatMoney(p.price)}</span>`}
                </div>
              </div>
            </a>`;
        });
        html += `</div></div>`;
      }

      if (collections.length) {
        html += `<div class="ss-divider"></div><div class="ss-section">
          <div class="ss-section-header"><span class="ss-section-title">Collections</span></div>
          <div class="ss-collection-grid">`;
        collections.slice(0, 4).forEach(c => {
          const imgSrc = c.featured_image?.url ? `${c.featured_image.url}&width=112` : null;
          html += `
            <a data-ss-url="${c.url}" class="ss-collection-item" role="option" aria-selected="false">
              <div class="ss-collection-img-wrap">${imgSrc ? `<img src="${imgSrc}" alt="${escapeHtml(c.title)}" width="56" height="56" loading="lazy">` : ''}</div>
              <span class="ss-collection-title">${highlight(c.title, query)}</span>
            </a>`;
        });
        html += `</div></div>`;
      }

      if (!products.length && !collections.length) {
        html = `<div class="ss-no-results">No results for "<strong>${escapeHtml(query)}</strong>"</div>`;
      }

      dropdown.innerHTML = html;
      finalizeOptions('results');
    }

    function finalizeOptions(state) {
      dropdown.querySelectorAll('[data-ss-url]').forEach(link => {
        link.setAttribute('href', link.dataset.ssUrl);
        link.removeAttribute('data-ss-url');
      });
      const options = [...dropdown.querySelectorAll('[role="option"]')];
      options.forEach((option, index) => {
        option.id = `${dropdown.id}-option-${index}`;
      });
      dropdown.dataset.ssState = state;
      showDropdown();
    }

    function showDropdown() {
      dropdown.style.display = 'block';
      input.setAttribute('aria-expanded', 'true');
    }
    function hideDropdown(cancelPending = true) {
      if (cancelPending) {
        requestSerial++;
        clearTimeout(debounceTimer);
        dropdown.removeAttribute('aria-busy');
      }
      dropdown.style.display = 'none';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      dropdown.querySelectorAll('[role="option"][aria-selected="true"]').forEach(option => {
        option.setAttribute('aria-selected', 'false');
      });
    }

    function setActiveOption(options, index) {
      options.forEach(option => option.setAttribute('aria-selected', 'false'));
      const option = options[index];
      if (!option) {
        input.removeAttribute('aria-activedescendant');
        return;
      }
      option.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    }

    input.addEventListener('input', event => {
      if (input.closest('search-modal')) event.stopImmediatePropagation();
      const q = input.value.trim();
      const requestId = ++requestSerial;
      clearTimeout(debounceTimer);
      if (q.length < 2) {
        dropdown.removeAttribute('aria-busy');
        if (q.length === 0 && document.activeElement === input) {
          renderZeroQuery();
        } else {
          hideDropdown();
        }
        return;
      }
      const intent = getIntentMatch(q);
      if (intent) {
        dropdown.removeAttribute('aria-busy');
        renderIntentSuggestions(intent);
        return;
      }
      hideDropdown(false);
      dropdown.replaceChildren();
      dropdown.dataset.ssState = 'loading';
      debounceTimer = setTimeout(async () => {
        dropdown.setAttribute('aria-busy', 'true');
        try {
          const data = await fetchSuggestions(q);
          if (requestId !== requestSerial) return;
          renderSuggestions(data, q);
        } catch (e) {
          console.error('Predictive search error:', e);
          if (requestId === requestSerial) hideDropdown();
        } finally {
          if (requestId === requestSerial) dropdown.removeAttribute('aria-busy');
        }
      }, 200);
    });

    document.addEventListener('click', e => {
      if (!input.closest('.input').contains(e.target)) hideDropdown();
    });

    const searchComponent = input.closest('.input');
    searchComponent.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!searchComponent.contains(document.activeElement)) hideDropdown();
      }, 0);
    });
    searchComponent.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || e.target === input) return;
      e.preventDefault();
      input.focus({ preventScroll: true });
      hideDropdown();
    });

    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        hideDropdown();
        return;
      }
      if (input.getAttribute('aria-expanded') !== 'true') return;
      const items = [...dropdown.querySelectorAll('[role="option"]')];
      if (!items.length) return;
      const current = items.findIndex(i => i.getAttribute('aria-selected') === 'true');
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const next = (current + 1) % items.length;
        setActiveOption(items, next);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = current < 0 ? items.length - 1 : (current - 1 + items.length) % items.length;
        setActiveOption(items, prev);
      } else if (e.key === 'Enter' && current >= 0) {
        e.preventDefault();
        items[current].click();
      }
    });

    input.addEventListener('focus', () => {
      const query = input.value.trim();
      if (query.length === 0) {
        renderZeroQuery();
      } else if (getIntentMatch(query)) {
        renderIntentSuggestions(getIntentMatch(query));
      } else if (query.length >= 2 && dropdown.dataset.ssState === 'results' && dropdown.innerHTML) {
        showDropdown();
      }
    });

    const form = input.closest('form');
    form?.addEventListener('submit', event => {
      const intent = getIntentMatch(input.value);
      if (!intent) return;
      event.preventDefault();
      window.location.assign(intent.destination);
    });
  }

  function initSearchInstances(root) {
    const allInputs = root.querySelectorAll('[data-search-input]:not([data-ss-init])');
    allInputs.forEach(input => {
      const dropdown = input.closest('.input')?.querySelector('[data-search-suggestions]');
      if (dropdown) {
        input.setAttribute('data-ss-init', 'true');
        initSearchInstance(input, dropdown);
      }
    });
  }

  initSearchInstances(document);
  document.addEventListener('shopify:section:load', event => initSearchInstances(event.target));

})();

